import React, { useEffect } from 'react';

import { useGetBusinessPlansLimits } from 'services/businessPlan/hooks';
import { useUserLimits } from 'store/useUserLimits';
import { getSetIsLimitsLoading, getSetUserLimits } from 'store/useUserLimits/selectors';
import { useUserStore } from 'store/useUserStore';
import { getAuthUser } from 'store/useUserStore/selectors';

import { useAuthenticated } from 'hooks/useAuthenticated';

import { IBusinessPlansLimits } from 'interfaces/businessPlan';

import ToastService from 'helpers/ToastService';

import { IAuthUserLimitsProviderProps } from './types';

export const AuthUserLimitsProvider: React.FC<IAuthUserLimitsProviderProps> = ({ children }) => {
  const authUser = useUserStore(getAuthUser);

  const setLimits = useUserLimits(getSetUserLimits);
  const setIsLimitsLoading = useUserLimits(getSetIsLimitsLoading);

  const { isAuthenticated } = useAuthenticated();

  const { data, isLoading, error, isFetching } = useGetBusinessPlansLimits({ enabled: !!authUser && isAuthenticated });

  useEffect(() => {
    if (data && !isFetching) {
      setLimits(data as IBusinessPlansLimits);
    }
  }, [data, isFetching]);

  useEffect(() => {
    setIsLimitsLoading(isLoading);
  }, [isLoading]);

  useEffect(() => {
    if (error) {
      ToastService.showError(error.message);
    }
  }, [error]);

  return <>{children}</>;
};
